import { INotifyDetached, IValidatable } from "../../../UI.BaseControls/ControlInterfaces";
import { ICellContent } from "./ICellContent";

export class TableCellContent implements ICellContent {
    private _visualElement: HTMLElement;
    private _dataElement: HTMLElement;
    private _validatableControl: IValidatable;

    public get visualElement(): HTMLElement {
        return this._visualElement;
    }

    public get dataElement(): HTMLElement {
        return this._dataElement;
    }

    public get validatableControl(): IValidatable {
        return this._validatableControl;
    }

    constructor(visualElement: HTMLElement, dataElement: HTMLElement, validatableControl: IValidatable) {
        this._visualElement = visualElement;
        this._dataElement = dataElement;
        this._validatableControl = validatableControl;
    }

    public detached(): void {
        if (this._validatableControl instanceof INotifyDetached)
            this._validatableControl.detached();
    }
}
